import React from 'react';
import { TextInput, TextInputProps, useMantineColorScheme } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

/**
 * Buscador estándar de la app: el mismo "pill" redondeado y translúcido del navbar.
 * Es un TextInput controlable (value/onChange/placeholder/onKeyDown…), para usarlo
 * en cualquier página y mantener una sola estética de búsqueda en toda la app.
 */
const SearchInput: React.FC<TextInputProps> = (props) => {
  const { colorScheme } = useMantineColorScheme();
  const dark = colorScheme === 'dark';

  return (
    <TextInput
      leftSection={<IconSearch size={16} />}
      radius="xl"
      {...props}
      styles={{
        input: {
          height: 38,
          backgroundColor: dark ? 'rgba(30, 41, 59, 0.7)' : 'rgba(247, 243, 238, 0.8)',
          border: `1px solid ${dark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(221, 216, 209, 0.8)'}`,
          color: dark ? '#e2e8f0' : '#2d2a26',
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px',
        },
        section: {
          color: dark ? '#94a3b8' : '#5a5550',
        },
        ...(props.styles as object),
      }}
    />
  );
};

export default SearchInput;
